import { NestedHome } from '@habity/types';

export type ProspectType = {
  imageUrl: string;
  prospectUrl: string;
  text: string;
};

export const hasProspect = (home: NestedHome) => {
  const { provider_data } = home || {};
  const { advertiseOn } = provider_data || {};
  const { links } = advertiseOn || {};
  const prospect = links?.find((link) => 
    link.links?.some((url) => url.startsWith('https://files.brandkeeper.se/flipbook/file'))
  );
  return !!prospect;
};

export const getProspect = (home: NestedHome) => {
  const { provider_data } = home || {};
  const { advertiseOn } = provider_data || {};
  const { links } = advertiseOn || {};
  const prospect = links?.findLast((link) => 
    link.links?.some((url) => url.startsWith('https://files.brandkeeper.se/flipbook/file'))
  );

  const { links: prospectLinks, text } = prospect || {};
  const prospectUrl = prospectLinks?.find((url) => 
    url.startsWith('https://files.brandkeeper.se/flipbook/file')
  ) || '';
  const imageUrl = prospectUrl
    ? 'https://files.brandkeeper.se/preview/file/' + prospectUrl.split('/').pop()
    : '';
  
  return {
    imageUrl,
    prospectUrl,
    text,
  } as ProspectType;
};
